// extracted by mini-css-extract-plugin
export default {"root":"_2cHiS","muroIcon":"_2PHiK","newIcon":"XZOum"};